import config from '@/config'
import axios from 'axios'

export default {
  functionsUrl: config.midServer[process.env.APP_CONF.instance],
  instanceUrl: config.firebase[process.env.APP_CONF.instance].authDomain,
  /**
   * Get user by email address
   * @param {string} email - user email
   */
  getUserByEmail(email) {
    return new Promise(resolve => {
      let url = `${this.functionsUrl}/getUserByEmail?email=${email}`

      axios.get(url).then(res => {
        resolve(res.data)
      })
    })
  },
  getUserList() {
    return new Promise(resolve => {
      let url = `${this.functionsUrl}/getUserList`

      axios.get(url).then(res => {
        resolve(res.data)
      })
    })
  },
  create(data) {
    data.instanceUrl = this.instanceUrl
    data.email = encodeURIComponent(data.email)

    return axios.post(`${this.functionsUrl}/createUser`, JSON.stringify(data))
  },
  addToDashboard(data) {
    data.instanceUrl = this.instanceUrl
    data.email = encodeURIComponent(data.email)

    return axios.post(`${this.functionsUrl}/addToDashboard`, JSON.stringify(data))
  },
  resetUserPass(data) {
    return axios.post(
      `${this.functionsUrl}/resetUserPass`,
      JSON.stringify(data)
    )
  },
}
